module.exports = __webpack_public_path__ + "img/f1-1.2b45c237.png";